import { render, staticRenderFns } from "./ArticlesAll.vue?vue&type=template&id=5cc98815"
import script from "./ArticlesAll.vue?vue&type=script&lang=js"
export * from "./ArticlesAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports